export default {
    text: 'Football Data',
    path: '/afl-football',
    icon: 'afl.svg',
    permissions: {
        AFLDATA: 'READ'
    },
    children: [
        {
            text: 'Matches',
            path: '/afl-football/matches',
            children: [],
            permissions: {
                AFLDATA: 'READ'
            }
        },
        {
            text: 'Teams',
            path: '/afl-football/teams',
            children: [],
            permissions: {
                AFLDATA: 'READ'
            }
        }
    ]
};
